
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CPLoginAsToolbar extends Vue {

  get cphqUser() {
    return this.$store.state.account.details.cphqUser;
  }
  get consultant() {
    return window.sessionStorage.getItem('consultantName');
  }
  public async logout() {
    await this.$store.dispatch('clearClientToken');
  }

  get username(): string {
    return (this.$store.state.account.details.name.length > 35) ? this.$store.state.account.details.name.substr(0, 35 - 1) + '...' : this.$store.state.account.details.name;
  }
}
